module.exports = __webpack_public_path__ + "static/media/Google-Technical-Support-Certification.721b1f56.png";